/* eslint-disable */
import '../../blocks/testimonials-slider/testimonials-slider';
import '../../blocks/applications-areas/applications-areas';
